export default {"src":"/_next/static/media/possibility_polygonoutline_group.b1fda713.svg","height":217,"width":265,"blurWidth":0,"blurHeight":0};